import { media } from 'styled-bootstrap-grid';
import { Link } from 'react-router-dom';
import Picture from '../../Picture/components/Picture';
import React, { Component } from 'react';
import SearchIcon from './Tile/SearchIcon';
import styled from 'styled-components';

const TileWrapper = styled.div`
  height: 0;
  overflow: hidden;
  position: relative;

  ${(props) => {
    if (undefined !== props.aspectRatio) {
      const ratio = props.aspectRatio.split(':');
      return `padding-bottom: ${(ratio[1] / ratio[0]) * 100}%;`;
    } else {
      return `padding-bottom: 75%;`;
    }
  }}
  ${media.xs`
    ${(props) => {
      if (undefined !== props.aspectRatioXs) {
        const ratio = props.aspectRatioXs.split(':');
        return `padding-bottom: ${(ratio[1] / ratio[0]) * 100}%;`;
      }
    }}
  `}
  ${media.sm`
    ${(props) => {
      if (undefined !== props.aspectRatioSm) {
        const ratio = props.aspectRatioSm.split(':');
        return `padding-bottom: ${(ratio[1] / ratio[0]) * 100}%;`;
      }
    }}
  `}
  ${media.md`
    ${(props) => {
      if (undefined !== props.aspectRatioMd) {
        const ratio = props.aspectRatioMd.split(':');
        return `padding-bottom: ${(ratio[1] / ratio[0]) * 100}%;`;
      }
    }}
  `}
  ${media.lg`
    ${(props) => {
      if (undefined !== props.aspectRatioLg) {
        const ratio = props.aspectRatioLg.split(':');
        return `padding-bottom: ${(ratio[1] / ratio[0]) * 100}%;`;
      }
    }}
  `}
  ${media.xl`
    ${(props) => {
      if (undefined !== props.aspectRatioXl) {
        const ratio = props.aspectRatioXl.split(':');
        return `padding-bottom: ${(ratio[1] / ratio[0]) * 100}%;`;
      }
    }}
  `}
`;
const TileWrapperInner = styled.div`
  left: 0;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
`;
const StyledLink = styled(Link)`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
  transition: all .25s;
  width: 100%;
`;
const PictureWrapper = styled.div`
  width: 100%;
  height: 100%;

  ::after {
    background: #000;
    content: "";
    display: block;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    transition: all .25s;
  }

  ${(props) => props.isHovering && `
    ::after {
      opacity: 0.5;
    }

    img {
      transform: scale(1.2);
    }
  `}

  img {
    min-height: 100%;
    transition: all .25s;
    flex-shrink: 0;
    min-width: 100%;
    object-fit: cover;
    ${media.lg`
      height: 100%;
    `}
  }
`;
const TextWrapper = styled.div`
  bottom: 0;
  color: #fff;
  display: block;
  left: 0;
  position: absolute;
`;
const Tag = styled.div`
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.1rem;
  line-height: 1.5rem;
  padding-left: 2.25rem;
  padding-right: 1rem;
  position: relative;
  text-transform: uppercase;
  z-index: 1;

  ::after {
    background-color: #635bff;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    transform-origin: left;
    transition: all 0.25s ease;
    width: 3%;
    z-index: -1;
  }

  ${(props) => props.isHovering && `
    ::after {
      width: 100%;
    }
  `}
`;
const Title = styled.div`
  padding: 0 2.25rem 2.25rem;
  font-size: 1.5rem;
`;

const isLinkExternal = ({ to, rel, target }) => {
  if (!to) return false;
  return !!((target && target !== '_self')
      || rel === 'external' || to.match(/^\w+:/) || to.match(/^\/\//) || to.match('#'));
};

const StyledFunctionalLink = (props) => {
  const { rel, target, ...restProps } = props;
  let targetWithSecurity = target;
  let securityChecks = [];
  if (isLinkExternal(props)) {
    securityChecks.concat(rel ? rel.split(' '): []);
    [ 'noopener', 'noreferrer' ].forEach((securityMeasure) => {
      if (!rel || !rel.includes(securityMeasure)) {
        securityChecks.push(securityMeasure);
      }
    });
    targetWithSecurity = '_blank';
  }
  const spreadSecurityChecks = {
    target: targetWithSecurity || null,
    rel: securityChecks.length ? securityChecks.join(' '): null,
  }
  return (<StyledLink {...restProps} {...spreadSecurityChecks} />)
};

class Tile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovering: false
    };
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  onMouseEnter() {
    this.setState({ isHovering: true });
  }

  onMouseLeave() {
    this.setState({ isHovering: false });
  }

  render() {
    const {
      aspectRatio,
      aspectRatioXs,
      aspectRatioSm,
      aspectRatioMd,
      aspectRatioLg,
      aspectRatioXl,
      image,
      path,
      sources,
      tags,
      title
    } = this.props;

    return <TileWrapper aspectRatio={aspectRatio}
                        aspectRatioXs={aspectRatioXs}
                        aspectRatioSm={aspectRatioSm}
                        aspectRatioMd={aspectRatioMd}
                        aspectRatioLg={aspectRatioLg}
                        aspectRatioXl={aspectRatioXl}
                        onMouseEnter={this.onMouseEnter}
                        onMouseLeave={this.onMouseLeave}>
      <TileWrapperInner>
        <StyledFunctionalLink to={path}>
          <PictureWrapper isHovering={this.state.isHovering}>
            {image && <Picture alt="Client Name" defaultSource={image} sources={sources} />}
          </PictureWrapper>
          <TextWrapper>
            <Tag isHovering={this.state.isHovering}>{tags}</Tag>
            <Title>{title}</Title>
          </TextWrapper>
          <SearchIcon isHovering={this.state.isHovering} />
        </StyledFunctionalLink>
      </TileWrapperInner>
    </TileWrapper>;
  }
}

export default Tile;
